const availableStages = [
    { _id: "Production", name: "Production" },
    { _id: "Test", name: "Test" },
    { _id: "Uat", name: "Uat" },
    { _id: "ValidationTest", name: "ValidationTest" },
    { _id: "Sandbox", name: "Sandbox" },
    { _id: "Development", name: "Development" },
    { _id: "PreProduction", name: "PreProduction" }];

const EnvrionmentConfig = {
    availableStages
}

export default EnvrionmentConfig;